import { useAtom } from "jotai";
import Loader from "../commons/Loader";
import { serviceSync } from "../../services/sync.service";
import MessagingHeaderNetworkStatus from "./MessagingHeader/MessagingHeaderNetworkStatus";

export type LoadingMessagesProps = {
}

export default function LoadingMessages({ }: LoadingMessagesProps) {
    const [progress] = useAtom(serviceSync.atomLoadingMessagesProgress);
    const [total] = useAtom(serviceSync.atomLoadingMessagesTotal);
    const [loadingMessagesType] = useAtom(serviceSync.atomLoadingMessagesType);

    return (
        <div className={`flex h-full justify-center items-center text-gray-500 flex-col gap-[15px] relative`}>
            <div className="flex gap-[5px]">
                Loading {loadingMessagesType === "text" ? "messages" : "media"} {(total > 0) ? <> <span className="text-gray-600">{progress}<span className="px-[2px]">/</span>{total}</span></> : "..."}
            </div>
            <Loader color="#ddd" />
            <div className="absolute top-0 right-0 h-[100px] pr-[25px] flex items-center">
                <MessagingHeaderNetworkStatus />
            </div>
        </div>
    );
}